/* eslint-disable max-statements */
import { CompanyIncrementalDay, WorkCenterWeek } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function canSubmitWorkCenterWeekQuery(
  this: UiQueries,
  workCenterWeek: WorkCenterWeek
): boolean {
  if (!this.uiState.isUserApprover) {
    return false;
  }

  if (workCenterWeek.justificationReason == null) {
    return false;
  }

  if (!this.hasUnsavedChangesForWorkCenterWeek(workCenterWeek)) {
    return false;
  }

  const hasRequestedThatDiffersFromUserData = (
    companyIncremental: CompanyIncrementalDay
  ) => {
    // there is an open request for this day
    const hasRequestedThatDiffersFromUserDataResult =
      companyIncremental.requested != null &&
      ((companyIncremental.userValue?.day != null &&
        companyIncremental.requested.day !==
          Number(companyIncremental.userValue?.day)) ||
        (companyIncremental.userValue?.night != null &&
          companyIncremental.requested.night !==
            Number(companyIncremental.userValue?.night)));

    return hasRequestedThatDiffersFromUserDataResult;
  };

  const hasApprovedThatDiffersFromUserData = (
    companyIncremental: CompanyIncrementalDay
  ) => {
    // has an approved for this day
    const hasApprovedThatDiffersFromUserDataResult =
      companyIncremental.approved != null &&
      ((companyIncremental.userValue?.day != null &&
        companyIncremental.approved.day !==
          Number(companyIncremental.userValue?.day)) ||
        (companyIncremental.userValue?.night != null &&
          companyIncremental.approved.night !==
            Number(companyIncremental.userValue?.night)));

    return hasApprovedThatDiffersFromUserDataResult;
  };

  // are the user changes any the same as what was retrieve from api?
  // Example: value from api was 5, user changed it in ui to 3, then back to 5
  // So in that case there is a user data in memory of 5, but it is no different
  // from the original value (no changes really).
  const userDataDiffersFromRequestedAndApproved = workCenterWeek.days.some(
    (day) =>
      day.incrementals
        .filter((companyIncremental) => companyIncremental.userValue != null)
        // eslint-disable-next-line complexity
        .some((companyIncremental) => {
          if (
            companyIncremental.requested != null &&
            hasRequestedThatDiffersFromUserData(companyIncremental)
          ) {
            return true;
          }

          if (
            companyIncremental.requested == null &&
            companyIncremental.approved != null &&
            hasApprovedThatDiffersFromUserData(companyIncremental)
          ) {
            return true;
          }

          // If there is no requested or approved, the ui defaults to zero.
          // However, if the user data value is a zero, it is a meaningless request (would have no effect on approved).
          if (
            companyIncremental.requested == null &&
            companyIncremental.approved == null &&
            companyIncremental.userValue?.day != null &&
            Number(companyIncremental.userValue.day) !== 0
          ) {
            return true;
          }

          // If there is no requested or approved, the ui defaults to zero.
          // However, if the user data value is a zero, it is a meaningless request (would have no effect on approved).
          if (
            companyIncremental.requested == null &&
            companyIncremental.approved == null &&
            companyIncremental.userValue?.night != null &&
            Number(companyIncremental.userValue.night) !== 0
          ) {
            return true;
          }

          return false;
        })
  );

  return userDataDiffersFromRequestedAndApproved;
}
